import React from 'react';

const getTotalDownTimeInHr = (moduleData: any) => {
  // // Check if moduleData is empty
  // if (!moduleData || moduleData.length === 0) {
  //   return null; // or any appropriate value
  // }

  // // Calculate the total downtime
  //  const totalDownTime = moduleData.reduce((sum: number, obj: any) => {
  //   // Convert down_time or total_down_time to a number (defaults to 0 if invalid)
  //   const downTime = +obj?.down_time || +obj?.total_down_time || 0;

  //   // Only add valid numbers (ignore NaN or invalid values)
  //   return !isNaN(downTime) ? sum + downTime : sum;
  // }, 0);

  // // Convert total downtime from minutes to hours and round to 2 decimal places
  // return +(totalDownTime / 60).toFixed(2);
  // return +(
  //   moduleData.reduce((sum: any, obj: any) => sum + +obj?.total_down_time, 0) / 60
  // ).toFixed(2);
  return +(
    moduleData.reduce((sum: any, obj: any) => sum + +obj?.down_time, 0)
  );
};
const TFoot = ({ moduleData }: any) => {
  console.log("moduledata is ",moduleData);
  return (
    <tr style={{ background: '#38d9a9' }}>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th align="center">
        TOTAL DOWN TIME IN HR : {getTotalDownTimeInHr(moduleData)}
      </th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
    </tr>
  );
};

export default TFoot;
